export default __webpack_public_path__ + "static/media/light.7f17b1e5.png";